import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';

import {
  getParPricingListByCriteria,
  PricingPackResponse,
} from '../../../services/pricing';
type UsePricingListParams = {
  mgid?: number;
  ctetype?: string;
  offerid?: number;
};
export type PricingInputProps = SelectProps<any> & {
  params: UsePricingListParams;
  value?: PricingPackResponse;
  onChange?: (pricing?: PricingPackResponse) => void;
  onClear?: () => void;
  disabled?: boolean;
  allowclear?: boolean;
};

const PricingInputConfig = ({
  params,
  value,
  onChange = noop,
  allowclear,
  onClear,
  ...otherProps
}: PricingInputProps) => {
  const { data: pricings, isLoading } = usePricingList(params);

  return (
    <Select
      {...otherProps}
      allowClear
      showSearch
      loading={isLoading}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      filterSort={(optionA, optionB) =>
        (optionA?.label ?? '')
          .toString()
          .toLowerCase()
          .localeCompare((optionB?.label ?? '').toString().toLowerCase())
      }
    >
      {pricings?.map((pricing: any) => (
        <Select.Option value={pricing.priid} key={pricing.priid}>
          {pricing.prilabel}
        </Select.Option>
      ))}
    </Select>
  );
};

const usePricingList = (params: UsePricingListParams) => {
  const getParPricingListByCriteriaRequest = useQuery(
    ['getParPricingListByCriteria'],
    () =>
      getParPricingListByCriteria({
        ctecategory: '',
        ctetype: String(params.ctetype),
        duration: 0,
        finamount: 0,
        priid: 0,
        prilabel: '',
        pristatus: '',
      }).then((res) => res.list || [])
  );

  return getParPricingListByCriteriaRequest;
};
export default PricingInputConfig;
